import { useCallback } from 'react';
import { Report } from '@elementary/common-ui/types';
import { EnvMode } from '@elementary/common-ui/constants';
import { useRecoilState } from 'recoil';
import * as atoms from '@/shared/store/atoms';
import localReport from '@/shared/store/elementary_output.json';

const useReport = () => {
  const [reportData, setReportData] = useRecoilState(atoms.report);

  const initReport = useCallback(
    (data?: Report) => {
      if (data) {
        setReportData(data);
        return;
      }

      if (
        import.meta.env.MODE === EnvMode.Development ||
        import.meta.env.MODE === EnvMode.Test
      ) {
        setReportData(localReport as unknown as Report);
        return;
      }

      setReportData(window.elementaryData);
    },
    [setReportData],
  );

  return { initReport, reportData };
};

export default useReport;
